export * from './CoreModule';
//# sourceMappingURL=index.web.js.map